
export const gtmPush = data => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(data)
}

/**
 * Track an event in Gtm data layer
 * @param {String} event - name of the event
 * @param {Object} params - additional parameters for the event
 */
export const trackInGtm = (event, params = {}) => {
  if (!event) return

  gtmPush({ event, ...params })
}
